module.exports = __webpack_public_path__ + "img/fa-brands.74eff2c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/font-awesome/fa-brands.svg
// module id = 911
// module chunks = 0